const EthereumLogo = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    viewBox="0 0 784 784"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M392.07 0L385.5 22.413V536.375L392.07 542.94L633.21 397.22L392.07 0Z"
      fill="#343434"
    />
    <path
      d="M392.07 0L150.92 397.22L392.07 542.94V290.57V0Z"
      fill="#8C8C8C"
    />
    <path
      d="M392.07 588.863L388.5 593.179V776.814L392.07 784L633.42 443.18L392.07 588.863Z"
      fill="#3C3C3B"
    />
    <path
      d="M392.07 784V588.863L150.92 443.18L392.07 784Z"
      fill="#8C8C8C"
    />
    <path
      d="M392.07 542.94L633.21 397.22L392.07 290.57V542.94Z"
      fill="#141414"
    />
    <path
      d="M150.92 397.22L392.07 542.94V290.57L150.92 397.22Z"
      fill="#393939"
    />
  </svg>
);

export default EthereumLogo; 